import { useEffect } from 'react';

// The browser tab's title while a page is open.
export function useDocumentTitle(title: string) {
  useEffect(() => { document.title = title; }, [title]);
}
